import { type Translation } from "./en";

export const ar: Translation = {
  ai_speech_preview_free_title: "الصوت القياسي",
  ai_speech_preview_free_desc: "صوت آلي مجاني",
  ai_speech_preview_pro_desc: "صوت عالي الجودة بنبرة طبيعية",
  ai_speech_preview_free_lbl: "مجاني",
  ai_speech_lang_support: "يدعم أكثر من 30 لغة",
  ai_speech_listen: "استمع للعينة",
  voice_type_none: "لا شيء",
  review_card_type: "اختر نوع البطاقة",
  custom_due_cards: "البطاقات المستحقة",
  custom_new_cards: "البطاقات الجديدة",
  review_custom: "اختر ما تريد مراجعته",
  settings_lang: "اللغة",
  logout: "تسجيل الخروج",
  error_contact_support: "حدث خطأ. يرجى الاتصال بالدعم حتى نتمكن من مساعدتك.",
  login_google: "تسجيل الدخول باستخدام Google",
  card_input_mode_changed: "تم تغيير وضع إدخال البطاقة",
  card_input_mode_manual: "إدخال يدوي",
  card_input_mode_type: "إذا كتبت",
  card_input_mode_get: "ستحصل على بطاقة مثل هذه",
  card_input_mode_screen: "وضع إدخال البطاقة",
  generate: "توليد",
  folder_form_no_decks: "لا توجد مجموعات في المجلد",
  cards_add: "إضافة بطاقات",
  card_next: "التالي",
  card_previous: "السابق",
  user_stats_empty_text: "ادرس المزيد من البطاقات لرؤية البيانات",
  read_more: "اقرأ المزيد",
  hide_card_forever: "إخفاء إلى الأبد",
  mute_cards: "كتم الصوت",
  unmute_cards: "إلغاء كتم الصوت",
  hide_card_forever_confirm_title:
    "هل أنت متأكد أنك تريد إخفاء هذه البطاقة إلى الأبد؟ لن تراها مرة أخرى",
  wysiwyg_big_header: "عنوان كبير",
  next: "التالي",
  review_again: "مرة أخرى",
  review_hard: "صعب",
  review_good: "جيد",
  review_easy: "سهل",
  wysiwyg_text_color: "لون النص",
  wysiwyg_bold: "عريض",
  wysiwyg_italic: "مائل",
  wysiwyg_undo: "تراجع",
  wysiwyg_clear_formatting: "مسح التنسيق",
  my_decks: "مجموعاتي",
  formatting: "التنسيق",
  deck: "مجموعة",
  deck_description: "مجموعة من البطاقات",
  folder: "مجلد",
  folder_description: "مجموعة من المجموعات",
  decks: "مجموعات",
  edit_folder: "تحرير المجلد",
  add_folder: "إضافة مجلد",
  add_deck_to_folder: "إضافة مجموعة إلى المجلد",
  decks_in_other_folders: "مجموعات في مجلدات أخرى",
  no_decks_to_add: "لا توجد مجموعات أخرى لإضافتها",
  show_all_decks: "عرض الكل",
  hide_all_decks: "إخفاء",
  select_all: "تحديد الكل",
  deselect_all: "إلغاء التحديد",
  select: "تحديد",
  selected: "محدد",
  browser_no_personal_decks_start: "ليس لديك أي مجموعة شخصية حتى الآن",
  browser_no_personal_decks_link: "تعلم كيفية استخدام MemoCard على ",
  browser_no_personal_decks_end: ". تعلم سعيد! 😊",
  add_deck: "إضافة مجموعة",
  add: "إضافة",
  edit_deck: "تحرير المجموعة",
  edit: "تحرير",
  view: "عرض",
  all_decks_reviewed: `عمل رائع! 🌟 لقد قمت بمراجعة جميع المجموعات حتى الآن. عد لاحقًا للمزيد.`,
  public_decks: "مجموعات عامة",
  explore_public_decks: "استكشاف المزيد من المجموعات",
  news_and_updates: "الأخبار والتحديثات",
  youtube_channel: "قناة يوتيوب",
  profile_section: "الملف الشخصي",
  telegram_channel: "قناة تيليجرام",
  settings: "الإعدادات",
  deck_has_been_added: "تمت إضافة هذه المجموعة إلى قائمتك",
  deck_catalog: "كتالوج المجموعات",
  translated_to: "مترجم إلى",
  any_language: "أي لغة",
  category: "الفئة",
  any_category: "أي",
  deck_search_not_found: "لم يتم العثور على مجموعات",
  card_search_not_found: "لم يتم العثور على بطاقات",
  deck_search_not_found_description:
    "حاول تحديث الفلاتر لرؤية المزيد من المجموعات",
  category_English: "الإنجليزية",
  category_Thai: "التايلاندية",
  category_Geography: "الجغرافيا",
  category_History: "التاريخ",
  category_Chemistry: "الكيمياء",
  category_Spanish: "الإسبانية",
  category_Other: "أخرى",
  save: "حفظ",
  add_card: "إضافة بطاقة",
  edit_card: "تحرير البطاقة",
  card_preview: "معاينة",
  add_card_short: "إضافة بطاقة",
  add_deck_short: "مجموعة",
  card_front_title: "الجانب الأمامي",
  card_back_title: "الجانب الخلفي",
  card_front_side_hint: "الموجه أو السؤال",
  card_back_side_hint: "الإجابة التي تحتاج إلى تقديمها",
  card_field_example_title: "مثال",
  card_field_example_hint: "معلومات إضافية اختيارية",
  cards: "بطاقات",
  search_card: "بحث عن بطاقة",
  card_sort_by_date: "التاريخ",
  card_sort_by_front: "الواجهة",
  card_sort_by_back: "الخلفية",
  sort_by: "ترتيب حسب",
  title: "العنوان",
  description: "الوصف",
  speaking_cards: "بطاقات ناطقة",
  voice_language: "لغة الصوت",
  card_speak_side: "جانب البطاقة",
  front: "الواجهة",
  back: "الخلفية",
  card_speak_description:
    "تشغيل الصوت المنطوق لكل بطاقة ذاكرة للاستماع إلى النطق",
  review_deck_finished: `لقد انتهيت من هذه المجموعة الآن 🎉`,
  review_all_cards: `لقد كررت جميع البطاقات لليوم 🎉`,
  review_finished_want_more: "تريد المزيد؟ لديك",
  review_finished_to_review: "للدراسة",
  review_deck: "مراجعة المجموعة",
  review_folder: "مراجعة المجلد",
  cards_to_repeat: "للتكرار",
  cards_new: "بطاقات جديدة",
  cards_total: "إجمالي البطاقات",
  duplicate: "تكرار",
  duplicate_deck_confirm: "هل أنت متأكد من تكرار هذه المجموعة؟",
  duplicate_folder_confirm: "هل أنت متأكد من تكرار هذا المجلد؟",
  delete_deck_confirm_shared: "إزالة المجموعة من مجموعتك؟",
  delete_folder_confirm_shared: "إزالة المجلد من مجموعتك؟",
  delete_deck_confirm_author:
    "إزالة المجموعة من MemoCard؟ لا يمكن التراجع عن هذا الإجراء",
  delete_folder_confirm_author:
    "إزالة المجلد من MemoCard؟ لا يمكن التراجع عن هذا الإجراء",
  deck_form_remove_card_confirm:
    "هل أنت متأكد أنك تريد إزالة البطاقة؟ ستفقد جميع مراجعات البطاقات من جميع المستخدمين",
  deck_form_remove_cards_confirm:
    "هل أنت متأكد أنك تريد إزالة جميع البطاقات المحددة؟",
  delete: "حذف",
  no_cards_to_review_in_deck: `عمل رائع! 🌟 لقد قمت بمراجعة جميع البطاقات في هذه المجموعة حتى الآن. عد لاحقًا للمزيد.`,
  repeat_cards_anyway: `كرر البطاقات على أي حال`,
  no_cards_to_review_all: `عمل رائع! 🌟 لقد كررت جميع البطاقات لليوم. عد لاحقًا للمزيد.`,
  review_show_answer: "عرض الإجابة",
  share: "مشاركة",
  warning_telegram_outdated_title: "تيليجرام الخاص بك قديم",
  warning_telegram_outdated_description:
    "يرجى تحديث تيليجرام لضمان عمل هذا التطبيق بشكل مستقر.",
  settings_review_notifications: "إشعارات المراجعة",
  settings_time: "الوقت",
  settings_review_notifications_hint:
    "التذكيرات اليومية تساعدك على تذكر تكرار البطاقات",
  validation_deck_title: "عنوان المجموعة مطلوب",
  deck_form_quit_card_confirm: "الخروج من تحرير البطاقة دون حفظ؟",
  quit_without_saving: "الخروج دون حفظ؟",
  folder_form_quit_card_confirm: "الخروج من تحرير المجلد دون حفظ؟",
  deck_form_quit_deck_confirm: "الخروج من تحرير المجموعة دون حفظ؟",
  deck_category: "فئة المجموعة",
  validation_required: "هذا الحقل مطلوب",
  share_link_copied: "تم نسخ الرابط إلى الحافظة",
  copied: "تم النسخ",
  copy_code: "نسخ الكود",
  html_column: "عمود",
  html_row: "صف",
  settings_contact_support: "الاتصال بالدعم في تيليجرام",
  settings_support_hint: "إذا كان لديك أي مشاكل أو أسئلة أو اقتراحات",
  payment_description: "افتح المزيد من الميزات",
  payment_choose_duration: "المدة",
  payment_choose_subscription: "الاشتراك",
  payment_choose_method: "طريقة الدفع",
  payment_method_usd: "بطاقة بنكية",
  payment_method_stars: "نجوم تيليجرام",
  payment_included: "ما هو مشمول",
  payment_paid_until: "مدفوع حتى",
  ai_cards_left: "بطاقات الذكاء الاصطناعي المتبقية هذا الشهر",
  payment_tos_and_pp_agree: "بشراء MemoCard، فإنك توافق على",
  payment_tos: "شروط الخدمة",
  payment_and: " و ",
  payment_pp: "سياسة الخصوصية",
  privacy_policy: "سياسة الخصوصية",
  go_back: "العودة",
  validation_at_least_one_deck: "يرجى اختيار مجموعة واحدة على الأقل",
  add_answer: "إضافة إجابة الاختبار",
  answer_text: "نص الإجابة",
  review_correct_label: "صحيح",
  review_wrong_label: "خطأ",
  advanced: "متقدم",
  review_idk: "لا أعرف",
  card_answer_type: "نوع البطاقة",
  yes_no: "تذكر",
  yes: "نعم",
  answer_type_choice: "اختبار",
  answer_type_explanation_remember: `بطاقة تحتوي على أزرار "تذكر" و "لا تتذكر"`,
  answer_type_explanation_choice: `بطاقة تحتوي على خيارات الإجابة`,
  validation_answer_at_least_one_correct: "يجب اختيار إجابة واحدة صحيحة",
  validation_at_least_one_answer_required: "يجب تقديم إجابة واحدة على الأقل",
  user_stats_btn: "الإحصائيات",
  user_stats_page: "إحصائياتي",
  user_stats_remembered: "تم تذكرها",
  user_stats_remembered_hint:
    "عدد البطاقات التي تمت مراجعتها بشكل صحيح 5 مرات متتالية",
  user_stats_learning: "التعلم",
  user_stats_learning_hint:
    "عدد البطاقات التي تمت مراجعتها أقل من 5 مرات متتالية",
  user_stats_total: "إجمالي البطاقات",
  user_stats_total_hint:
    "إجمالي عدد البطاقات التي تم فتحها مرة واحدة على الأقل",
  user_stats_learning_time: "توزيع وقت التعلم",
  user_stats_learning_time_hint:
    "كيف يتم تخصيص وقتك بين تعلم مواد جديدة والمراجعة",
  user_stats_chart_min_expl: "لا أعرف البطاقة",
  user_stats_chart_max_expl: "أعرف البطاقة جيدًا",
  validate_positive: "يرجى إدخال رقم موجب",
  validate_under_100: "يرجى إدخال رقم أقل من 100",
  freeze_confirm_freeze:
    "هل أنت متأكد أنك تريد تجميد بطاقاتك؟ لا يمكن التراجع عن هذا الإجراء.",
  freeze_title: "تجميد البطاقات",
  how: "كيف يعمل",
  freeze_rule_1: "سيتم إيقاف جميع بطاقاتك مؤقتًا، ولن تتلقى أي إشعارات.",
  freeze_rule_2:
    "لن يزيد عدد البطاقات التي يجب مراجعتها خلال فترة التجميد؛ سترى نفس عدد البطاقات عند استئناف الدراسة.",
  freeze_rule_3: "لا يمكن التراجع عن تجميد البطاقات.",
  freeze_rule_4: "إذا أضفت بطاقة خلال فترة التجميد، فلن تتأثر بالتجميد.",
  freeze_for: "تجميد لمدة",
  freeze_for_or_manual: "أو اكتب يدويًا",
  freeze_notified: "ستتلقى إشعارًا في",
  freeze_hint: "تأجيل دراسة البطاقات",
  ui_loading: "جارٍ التحميل...",
  is_on: "تشغيل",
  is_off: "إيقاف",
  error_solving: "نحن نحل المشكلة",
  error: "خطأ",
  user_settings_updated: "تم تحديث الإعدادات",
  ai_cards_generate: "توليد البطاقات",
  ai_cards_title: "توليد البطاقات باستخدام الذكاء الاصطناعي",
  ai_cards_previous_prompts: "تاريخ الطلبات",
  ai_cards_no_previous_prompts: "لا توجد طلبات سابقة",
  ai_cards_prompt: "الوصف",
  ai_cards_prompt_front: "وصف واجهة البطاقة",
  ai_cards_prompt_back: "وصف خلفية البطاقة",
  ai_cards_by_ai: "بطاقات تم توليدها بواسطة الذكاء الاصطناعي",
  ai_cards_confirm_delete: "هل أنت متأكد أنك تريد حذف هذه البطاقة؟",
  ai_cards_added: "تمت إضافة البطاقات",
  ai_cards_use_template: "استخدام القالب",
  payment_success: "تم الدفع بنجاح. استمتع بالميزات الإضافية 😊",
  confirm_cancel: "إلغاء",
  confirm_ok: "تأكيد",

  upgrade_pro: "الترقية إلى Pro",

  payment_failed:
    "فشل الدفع. نحن على علم بالمشكلة ونعمل على حلها. يرجى الاتصال بالدعم عبر الإعدادات > الدعم.",

  ai_card_input_mode_supports: "يدعم لغات مختلفة",

  ai_speech_title: "الذكاء الاصطناعي الصوتي",
  ai_speech_empty:
    "لم يتم توليد أي صوت بالذكاء الاصطناعي. اختر جانب البطاقة أدناه.",
  ai_speech_type: "أو اكتب النص المطلوب",
  ai_speech_generate: "توليد",
  ai_speech_validate: "يرجى اختيار الجانب أو كتابة النص",

  // Global Search
  global_search_placeholder: "البحث في المجموعات، المجلدات، البطاقات",
  global_search_no_results: "لا توجد نتائج",
  global_search_cancel: "إلغاء",
  global_search_start_typing:
    "ابدأ الكتابة للبحث في المجموعات والمجلدات والبطاقات",
  global_search_tabs_cards: "البطاقات",
  global_search_tabs_decks: "المجموعات",
  global_search_tabs_folders: "المجلدات",
  global_search_context_folder: "مجلد",
  global_search_context_deck: "مجموعة",

  // About page
  about_title: "حول التطبيق",
  about_paragraph_1:
    "صنعت MemoCard لأن تطبيقات مثل Anki صعبة الاستخدام. نعم هي قوية، لكنها تحتاج ساعات من الإعدادات، لا تذكرك بالمراجعة، وشكلها قديم.",
  about_paragraph_2:
    "في مسابقة تطبيقات Telegram الصغيرة، صنعت تطبيق البطاقات الذي أحلم به. لا يحتاج أي إعدادات، التذكيرات تعمل تلقائياً، وكل شيء بسيط.",
  about_paragraph_3:
    "يعتمد على طريقة التكرار المتباعد العلمية لإبنجهاوس. البطاقات تظهر في الوقت المناسب - عندما تبدأ بالنسيان. هكذا تحفظ أفضل.",
  about_paragraph_4:
    "MemoCard فاز بجائزة في المسابقة. الآن يستخدمه آلاف الناس حول العالم.",
  about_visit_website: "زيارة الموقع →",
  about_github_frontend: "مستودع GitHub للواجهة الأمامية →",

  // Card Input Mode Form
  card_input_mode_form_title: "العنوان",
  card_input_mode_form_ai_prompt: "طلب الذكاء الاصطناعي",
  card_input_mode_form_create_title: "إنشاء وضع الإدخال",
  card_input_mode_form_edit_title: "تحرير وضع الإدخال",
  card_input_mode_form_delete_confirm: "حذف وضع الإدخال هذا؟",
  card_input_mode_add_button: "إضافة وضع إدخال",
  card_input_mode_form_title_placeholder: "مثال: تعريفات إنجليزية",
  card_input_mode_form_prompt_placeholder:
    "مثال: أنشئ بطاقة تعريف للكلمة :template_word",
  card_input_mode_form_front_placeholder: "مثال: كلمة أو مصطلح",
  card_input_mode_form_back_placeholder: "مثال: تعريف بسيط",
  card_input_mode_form_example_placeholder: "مثال: مثال استخدام أو سياق",
  card_input_mode_form_save_success: "تم حفظ وضع الإدخال",
  card_input_mode_form_delete_success: "تم حذف وضع الإدخال",
  quit_card: "الخروج من البطاقة",

  // Wysiwyg Help
  wysiwyg_help_title: "دليل تنسيق النص",
  wysiwyg_help_step1: "حدد النص الذي تريد تغييره",
  wysiwyg_help_step2: "اضغط على أي زر من شريط الأدوات",
  wysiwyg_help_bold: "نص عريض",
  wysiwyg_help_italic: "نص مائل",
  wysiwyg_help_color: "تغيير لون النص",
  wysiwyg_help_heading: "جعل النص أكبر (عنوان)",
  wysiwyg_help_table: "إدراج جدول",
  wysiwyg_help_clear: "إزالة جميع التنسيقات",
  wysiwyg_help_undo: "التراجع عن آخر إجراء",

  reverse_cards: "بطاقات عكسية",
  reverse_cards_title: "البطاقات العكسية",
  reverse_cards_helper:
    "أنشئ واحدة واحصل على اثنتين. يساعد على التذكر بشكل أفضل",
  two_cards_created: "تم إنشاء بطاقتين",
  card_created: "تم إنشاء البطاقة",

  // Move card to deck
  move_card_to_deck_title: "نقل إلى رزمة",
  move_card_without_folder: "بدون مجلد",
  move_card_move: "نقل",
  move_card_open_deck: "فتح الرزمة",

  // Image related
  image: "صورة",

  // Skip card
  skip_card_for_now: "تخطي الآن",
  skip_card_confirm: "تخطي هذه البطاقة؟ ستكون مخفية حتى المراجعة القادمة",
  review_skipped: "تم التخطي",
};
